import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import moment from 'moment';
import { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useNavigate } from 'react-router-dom';
import * as Yup from "yup";
import StickButtonsBloc from '../../blocs/common/StickButtonsBloc';
import { APP_URLS, ERROR_MESSAGES } from '../../const/AppConst';
import useAppState from '../../context/AppContext';
import { IAdditionalOption, IBeneficiaryAdditionReq, relationType } from "../../context/model";
import MgpMessage from "../../elements/MgpMessage/MgpMessage";
import { useFetchNomenclature } from "../../hooks/useFetchNomenclature";
import LoaderModal from "../../modals/common/LoaderModal";
import { isPropositionInLock } from "../../utils/dataUtils";
import { calculNirKey, getAllIndexByString, isValidDate } from "../../utils/utils";
import InfoBeneficiaryComponent, { InfoBeneficiaryStep1FormData, InfoBeneficiaryStep1FormDataProps } from "./InfoBeneficiaryComponent";

interface ValidateOptionsExtended {
  options: {
      index: number;
  };
}


export default function InfoBeneficiaryStep1DemoFormComponent() {
  const [errorMsg, setErrorMsg] = useState<string | null>();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedBeneficiary, setSelectedBeneficiary] = useState<InfoBeneficiaryStep1FormDataProps>();
  const [index, setIndex] = useState<number>(0);
  const [isNew, setIsNew] = useState<boolean>(false);
  const [error, setError] = useState<number[]>([]);

  const navigate = useNavigate();

  const {
    state: { proposition, updatedProposition, showModal, additionals },
    dispatch,
  } = useAppState();

  useFetchNomenclature("civility");
  useEffect(() => {
    let additionalsArr = additionals ? [...additionals] : [] as IAdditionalOption[];
    let beneficiariesArr = updatedProposition!.beneficiaries!.length > 0 ? updatedProposition!.beneficiaries!.filter(bene => bene.relationType) : [] as IBeneficiaryAdditionReq[];
    if (beneficiariesArr.length > 0) {
      beneficiariesArr.map(beneficiary => {
        const i = additionalsArr.findIndex(element => beneficiary.contact.contactId ? element.id === beneficiary.contact.contactId : element.id === beneficiary.contact.nir);
        if (i === -1) {
          additionalsArr.push({type: 'Ayant droit', name: `${beneficiary.contact.firstName} ${beneficiary.contact.lastName}`, amount: 20, id: beneficiary.contact.contactId || beneficiary.contact.nir})
        }
      })
      dispatch({type: 'ADD_ADDITIONAL_OPTION', additionals: additionalsArr});
    }
  }, [])

  const schemas = {} as any;
  let beneficiaryPropsMap = [] as InfoBeneficiaryStep1FormDataProps[];
  if(updatedProposition?.beneficiaries && updatedProposition.beneficiaries.length > 0) {
    beneficiaryPropsMap = updatedProposition?.beneficiaries?.map((extractedInfo, index) => {   
      const beneficiaryProps = {
        withBeneficiary: extractedInfo.relationType ? true : false,
        onModify: false,
        ...extractedInfo
      } as InfoBeneficiaryStep1FormDataProps;
      
      return beneficiaryProps;
    });
  }
   
  const validationSchema = Yup.object().shape({
    ayantDroits: Yup.array()
    .of(
      Yup.object().shape({
        relationType: Yup.string()
        .when('onModify', {
          is: (onModify: boolean) => onModify,
          then: Yup.string().required(ERROR_MESSAGES.requiredMsg)
        }),
        contact: Yup.object().when('onModify', {
          is: (onModify: boolean) => onModify,
          then: Yup.object().shape({
            civilityCode: Yup.string()
            .required(ERROR_MESSAGES.requiredMsg),
            firstName: Yup.string()
            .required(ERROR_MESSAGES.requiredMsg)
            .min(2, ERROR_MESSAGES.invalidMsg)
            .max(50, ERROR_MESSAGES.invalidMsg)
            .matches(/^[a-zA-Z '-]+$/i, ERROR_MESSAGES.invalidName)
            .test('invalidCombination', ERROR_MESSAGES.invalidMsg, (val)=> {
              let invalidCase = val?.includes('--') === true ;
              let isDashInTheMiddle;
              if(val){
                const indexList = getAllIndexByString(val, "-");
                isDashInTheMiddle = indexList.indexOf(0) !== -1 || indexList.indexOf(val.length-1) !== -1;
              }
              return !invalidCase && !isDashInTheMiddle;
            }),
            lastName: Yup.string()
            .required(ERROR_MESSAGES.requiredMsg)
            .min(2, ERROR_MESSAGES.invalidMsg)
            .max(50, ERROR_MESSAGES.invalidMsg)
            .matches(/^[a-zA-Z '-]+$/i, ERROR_MESSAGES.invalidName)
            .test('invalidCombination', ERROR_MESSAGES.invalidMsg, (val)=> {
              let invalidCase = val?.includes('--') === true ;
              let isDashInTheMiddle;
              if(val){
                const indexList = getAllIndexByString(val, "-");
                isDashInTheMiddle = indexList.indexOf(0) !== -1 || indexList.indexOf(val.length-1) !== -1;
              }
              return !invalidCase && !isDashInTheMiddle;
            }),
            birthDate: Yup.string()
            .required(ERROR_MESSAGES.requiredMsg)
            .test("validDate", ERROR_MESSAGES.invalidMsg, (val) => {
              var now = new Date();
              now.setHours(0,0,0,0);
              return val !== undefined && isValidDate(val) && new Date(val) < now;
            }),
            nir: Yup.string().required(ERROR_MESSAGES.requiredMsg)
            .min(13, ERROR_MESSAGES.invalidMsg)
            .max(13, ERROR_MESSAGES.invalidMsg),
            // .when('civilityCode', (civilityCode, schema) => {
            //   return schema.test("follow_civility", "La valeur ne correspond pas à sa civilité", (val:string) => {
            //     return (civilityCode === CIVILITY_MONSIEUR_CODE && val?.startsWith("1")) || (civilityCode === CIVILITY_MADAME_CODE && val?.startsWith("2"));
            //   }); 
            // })
            // .when('birthDate', (birthDate, schema) => {
            //   if(birthDate && moment(birthDate).isValid()) {
            //     return schema.test("follow-birthDate", "La valeur ne correspond pas à sa date de naissance", (val:string) => {
            //       return val && birthDate.substring(5, 7) === val.substring(3,5) && birthDate.substring(2, 4) === val.substring(1,3);
            //     }); 
            //   }        
            //   return schema;
            // }), 
            nirKey: Yup.string()
            .required(ERROR_MESSAGES.requiredMsg)
            .min(2, ERROR_MESSAGES.invalidMsg)
            .max(2, ERROR_MESSAGES.invalidMsg)
            .when('nir', (nir, schema) => {
            return schema.test("nir-val", ERROR_MESSAGES.invalidMsg, (val: string) => {
              return val && Number(val) && nir && val === calculNirKey(nir);
              }); 
            }),
            attachmentOrganization: Yup.string().required(ERROR_MESSAGES.requiredMsg)
            .min(9, ERROR_MESSAGES.invalidMsg)
            .max(9, ERROR_MESSAGES.invalidMsg)
            .matches(/^[0-9]+$/i, ERROR_MESSAGES.invalidMsg),
          })
        }),
      })
    )
  });    

  const {
    register,
    handleSubmit,setValue, control, watch, getValues,
    formState: { errors, isSubmitting },
  } = useForm<InfoBeneficiaryStep1FormData>({
    defaultValues: {
      ayantDroits: beneficiaryPropsMap
    },
    mode: "onBlur",
    reValidateMode: "onChange",
    resolver: yupResolver(validationSchema),
  });

  const { fields, append, remove, update } = useFieldArray({
    name: "ayantDroits",
    control
  });

  const onNextAction = (beneficiaries: InfoBeneficiaryStep1FormData) => {
    setErrorMsg(null);
    const invalid = beneficiaries.ayantDroits.findIndex(el => !el.withBeneficiary)

    if(invalid !== -1) {
      setErrorMsg('Veuillez compléter ou supprimer le(s) ayant(s) droit(s) ci-dessous.');
      let errorArr = [] as number[];
      beneficiaries.ayantDroits.map((el, i) => {
        if (!el.withBeneficiary) {
          errorArr.push(i);
        }
      });
      setError(errorArr);
    } else {
      let tempUpdatedPropo = updatedProposition;
      if(tempUpdatedPropo) {
        const data = Object.entries(beneficiaries.ayantDroits).filter(([_, beneficiary]) => beneficiary.withBeneficiary).map( ([_, beneficiary]) => {
            return {
              relationType: beneficiary.relationType,
              contact: beneficiary.contact,
              isConfirmed: beneficiary.isConfirmed
            };
        })  
        tempUpdatedPropo.beneficiaries = data;
      }

      dispatch({type: 'NEXT_INFO_STEP', path: APP_URLS.infoOptionsPage, updatedProposition: tempUpdatedPropo});
      navigate({
        pathname: APP_URLS.infoOptionsPage,
        search: `?id=${proposition!.propositionId}`,
      });
    }
  }
  
  const onPreviousAction = () => {
    dispatch({type: 'BACK_INFO_STEP', path: APP_URLS.infoBeneficiaryStep0Page});
    navigate({
      pathname: APP_URLS.infoBeneficiaryStep0Page,
      search: `?id=${proposition!.propositionId}`,
    });
  }

  const handleOpenForm = (e: any) => {
    e.preventDefault();
    const beneficiaryProps = {
      withBeneficiary: true,
      onModify: true,
      contact: {
        firstName: '',
        lastName: '',
        birthDate: '',
        civilityCode: '',
        regimeCode: '',
        attachmentOrganization: '',
        nir: '',
        nirKey: ''
      }
    } as InfoBeneficiaryStep1FormDataProps;

    append(beneficiaryProps);
    setIsOpen(true);
    setSelectedBeneficiary(beneficiaryProps);
    setIndex(fields.length);
    setIsNew(true);
    dispatch({type: 'SHOW_MODAL', showModal: true});
  }

  const handleOpenModal = (e: any, beneficiary: InfoBeneficiaryStep1FormDataProps, i: number) => {
    e.preventDefault();
    setIsOpen(true);
    setSelectedBeneficiary(beneficiary);
    setValue(`ayantDroits.${i}.onModify`, true);
    setIndex(i);
    dispatch({type: 'SHOW_MODAL', showModal: true});
  }

  const handleDeleteAyantDroit = (i: number) => {
    remove(i);
    setIsNew(false);
    let additionalsArr = additionals ? [...additionals] : [] as IAdditionalOption[];
    const indexFound = additionalsArr.findIndex(element => getValues(`ayantDroits.${i}.contact.contactId`) ? element.id === getValues(`ayantDroits.${i}.contact.contactId`) : element.id === getValues(`ayantDroits.${i}.contact.nir`));
    if (indexFound !== -1) {
      additionalsArr.splice(indexFound, 1);
      dispatch({type: 'ADD_ADDITIONAL_OPTION', additionals: additionalsArr});
    }
  }

  const onConfirmAction = () => {
    setIsOpen(false);
    dispatch({type: 'SHOW_MODAL', showModal: false});
    if (selectedBeneficiary) {
      const data = {...selectedBeneficiary}
      data.withBeneficiary = true;
      data.onModify = false;
      data.relationType = getValues(`ayantDroits.${index}.relationType`);
      data.contact = getValues(`ayantDroits.${index}.contact`);
      update(index, data);
    }
    setIsNew(false);
    const indexError = error.indexOf(index);
    if (indexError !== -1) {
      const newErrorArr = [...error];
      newErrorArr.splice(indexError, 1);
      setError(newErrorArr);
    }

    let additionalsArr = additionals ? [...additionals] : [] as IAdditionalOption[];
    const i = additionalsArr.findIndex(element => getValues(`ayantDroits.${index}.contact.contactId`) ? element.id === getValues(`ayantDroits.${index}.contact.contactId`) : element.id === getValues(`ayantDroits.${index}.contact.nir`));
    if (i === -1) {
      additionalsArr.push({type: 'Ayant droit', name: `${getValues(`ayantDroits.${index}.contact.firstName`)} ${getValues(`ayantDroits.${index}.contact.lastName`)}`, amount: 20, id: getValues(`ayantDroits.${index}.contact.contactId`) || getValues(`ayantDroits.${index}.contact.nir`)})
      dispatch({type: 'ADD_ADDITIONAL_OPTION', additionals: additionalsArr});
    }
  }

  const onRefuseAction = () => {
    setIsOpen(false);
    dispatch({type: 'SHOW_MODAL', showModal: false});
    setValue(`ayantDroits.${index}.onModify`, false);
    if (isNew) {
      remove(index);
      setIsNew(false);
    }


  }


  return (
    <form style={{width: '100%'}}>
      <div>
        {errorMsg && <MgpMessage type="danger" message={errorMsg} hasCloseBtn={false}/>}
      </div>
        
      <div className='grid-flex jc-start'>
        {fields.map((field, i )=> 
          <div key={i} className={`card-contrats hover box ${error.includes(i) && 'box-error'} ${field.withBeneficiary && 'box-selected'}`}>
          <div className='card' style={{gap: 0, flexWrap: "nowrap"}}>
            <div className="grid-flex jc-space-arround jc-start" >
            <i className='icon-personne bleu fz-lg'></i>
            {field.withBeneficiary && <i className="icon-coche fz-lg" style={{marginLeft: "auto"}}></i>}
            </div>
            
            {field.relationType &&<p className=''>{field.relationType === relationType.CHILD ? "Enfant" : "Conjoint(e)"}</p>}
            <p className='fz-lg fw-medium mt-md bleu'>{`${field.contact.firstName} ${field.contact.lastName}`}</p>
            <p>{moment(field.contact.birthDate).format("DD/MM/YYYY") || ''}</p>

            <p className="fz-lg fw-medium m-y-md"> 20€ / mois *</p>

            <div className="wrapper-cta-inline m-y-lg">
            {field.withBeneficiary ? <button className="cta-blanc cta-small" style={{border: "1px solid #144196"}} onClick={(e) => handleOpenModal(e, field, i)}>Modifier</button> : <button className="cta-bleu cta-small" onClick={(e) => handleOpenModal(e, field, i)}>Compléter</button>}
            </div>
            <div className="wrapper-cta-inline mt-lg">
              <a className="cta-blanc cta-small" href="#" onClick={() => handleDeleteAyantDroit(i)}>Supprimer cet ayant droit</a>
            </div>
            
          </div>
        </div>)}

        <div className='box card-contrats hover' >
          <div className='card'>
            <i className='icon-plus bleu fz-lg'></i>
            <div className="wrapper-cta-inline m-y-lg"><button className="cta-bleu cta-small" onClick={(e) => handleOpenForm(e)}>Ajouter un ayant droit</button></div>
          </div>
        </div>
      </div>

      <div className="bg-menthe blanc p-x-sm p-y-md m-y-lg">
          <p>
          En ajoutant ce(s) ayant(s) droit, le montant total restant à votre charge est : <strong>{additionals.filter(el => el.type === "Ayant droit").reduce((acc, val) => acc + val.amount, 0)} € / mois</strong>
          </p>
      </div>
      <p className="text">(*) : Cotisation à votre charge</p>
  
      {isOpen && selectedBeneficiary && <InfoBeneficiaryComponent isOpen={isOpen} onCloseModal={() => {
        setIsOpen(false);
        dispatch({type: 'SHOW_MODAL', showModal: false});
      }}  
        onConfirmAction={handleSubmit(onConfirmAction)} onRefuseAction={onRefuseAction}
        register={register} errors={errors} watch={watch} setValue={setValue} contact={selectedBeneficiary.contact} relationType={selectedBeneficiary.relationType} id={index} isConfirmed={selectedBeneficiary.isConfirmed}
      />}

      {
        !showModal && <StickButtonsBloc disabledPreviousButton={proposition && isPropositionInLock(proposition) ? true : false} showNextButton={true} showPreviousButton={true} previousAction={onPreviousAction} nextAction={() => onNextAction(getValues())}/>
      }

      {/* {proposition && isPropositionInLock(proposition) ? (<StickButtonsBloc disabledPreviousButton={true} showNextButton={true} showPreviousButton={true} previousAction={onPreviousAction} nextAction={() => onNextAction(getValues())}/>) : (<StickButtonsBloc showNextButton={true} showPreviousButton={true} previousAction={onPreviousAction} nextAction={() => onNextAction(getValues())}/>)} */}
        
      {isSubmitting&&<LoaderModal hasMessage={false}/>}
       
    </form>
  )
}
